export class AdicionarLojaModel {
    constructor(
       public documento: string = '',
       public razaoSocial: string = '',
    ) { }
 }